import "./RightView.css";

import { NavLink } from "react-router-dom";
import React from "react";
import { getAuthorImage, getAuthorName } from "../../../../helper";

function RightView({ homeData }) {
  return (
    <div className="RightView">
      <div className="RightView-title">Columns</div>
      <div className="RightView-news">
        {homeData.columns.map((newsItem, index) => {
          const imageURL = getAuthorImage(newsItem) ?? newsItem.imageUrl;
          return (
            <div key={index}>
              <div className="news-title">{newsItem.heading}</div>
              <div className="news-auther">By {getAuthorName(newsItem)}</div>
              <NavLink to="/columns" className="news-item-link">
                <div className="news-item">
                  {!!imageURL && (
                    <img
                      src={imageURL}
                      height={90}
                      width={90}
                      alt="news-img"
                      style={{
                        backgroundColor: "#A9A9A9",
                        marginRight: 20,
                        borderRadius: 8,
                        // objectFit: 'cover',
                      }}
                    />
                  )}
                  <div className="news-content">
                    <div className="news-description">
                      {newsItem.subHeading}
                    </div>
                  </div>
                </div>
              </NavLink>
            </div>
          );
        })}
      </div>
      <div className="news-link">
        <NavLink to="/columns" className="news-clickable-text">
          See Full List
        </NavLink>
        <span>
          <img src="./assets/Vector.png" alt="arrow" className="arrow-img" />
        </span>
      </div>
      <div className="bottom-view">
        {/* <div className='bottom-view-title'>Recommended Topics</div> */}

        {/* <div className='topics'>
          {homeData?.topics?.map((topic) => (
            <span key={topic} className='topic-item'>
              {topic}
            </span>
          ))}
        </div>
        <div className='news-link'>
          <NavLink to='/podcasts' className='news-clickable-text'>
            See more topics
          </NavLink>
          <span>
            <img src='./assets/Vector.png' alt='arrow' className='arrow-img' />
          </span>
        </div> */}
      </div>
    </div>
  );
}

export default RightView;
